import pluralize from "pluralize";
import {TbMinusVertical} from "react-icons/tb";

import {SLAReport, SLAReportResponseTime} from "@/lib/queries/reports.ts";
import {formatResponseTime} from "@/pages/checks/analysis/overview/utils.ts";
import {SLAReportServiceResponseTimeTable} from "@/pages/reports/sla/details/responsetime/SLAReportServiceResponseTimeTable.tsx";

interface SLAReportResponseTimeItemProps {
  report: SLAReport;
  item: SLAReportResponseTime;
  className?: string;
}

export const SLAReportResponseTimeItem = ({report, className, item}: SLAReportResponseTimeItemProps) => (
  <div className={className}>
    <div className="row">
      <div className="col-6">
        <h3 className="fw-bold fs-5 mb-0">{item.name}</h3>
      </div>
      <div className="col-6 d-flex flex-row-reverse align-items-center">
        <span className="">Avg. response time: {formatResponseTime(item.response_time_avg)}</span>
        <TbMinusVertical className="mx-1" />
        <span className="text-muted">
          {item.services.length} {pluralize("Check", item.services.length)}
        </span>
      </div>
    </div>
    <div className="row mb-3 mt-4">
      <SLAReportServiceResponseTimeTable report={report} item={item} />
    </div>
  </div>
);
